/* Waxit wishlist. Swym stores the list and sends alerts; we own every pixel. Buttons carry .wx-wish + data-product-id/data-variant-id. */
(function () {
  var SEL = '[data-pv7-wish], .wxh-card__wish, .wxh-card__btn--notify';
  /* Units: Swym items (it.pr / it.op) are in DOLLARS; Shopify /products/x.js prices are in CENTS. Never guess from magnitude — a $4 item came back as $400. */
  var money = function (dollars) { var f = (window.wx && window.wx.moneyFormat) || '$' + '{{amount}}'; var v = Number(dollars) || 0; return f.replace(/\{\{\s*amount[^}]*\}\}/, v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')); };
  var moneyCents = function (cents) { return money((Number(cents) || 0) / 100); };
  function setCount(n) {
    document.querySelectorAll('[data-wx-wish-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
    var c = document.querySelector('[data-wxw-count]'); if (c) { c.textContent = n; c.hidden = !n; }
  }
  function inList(items, b) {
    var epi = String(b.getAttribute('data-variant-id')), empi = String(b.getAttribute('data-product-id'));
    return (items || []).find(function (it) { return String(it.epi) === epi || (String(it.empi) === empi && (it.epi == null || it.epi === it.empi)); });
  }
  function mark(items) {
    document.querySelectorAll(SEL).forEach(function (b) {
      if (b.dataset.busy) return;
      var on = !!inList(items, b);
      b.classList.toggle('swym-added', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    var list = [], ready = false, swapping = false;
    var root = document.querySelector('[data-wx-wishlist]');
    if (root && root.parentNode !== document.body) document.body.appendChild(root); /* escape the header's stacking context */
    /* While a row is mid variant-swap (add new, remove old) Swym's list briefly holds both; skip those refreshes so the row never doubles up. */
    function refresh(cb) { try { swat.fetch(function (items) { if (swapping) { if (cb) cb(); return; } list = items || []; setCount(list.length); mark(list); render(); ready = true; if (cb) cb(); }, function () { ready = true; if (cb) cb(); }); } catch (e) { ready = true; if (cb) cb(); } }
    refresh();
    var ev = swat.JSEvents || {}, L = swat.evtLayer;
    if (L && L.addEventListener) [ev.addedToWishlist, ev.removedFromWishlist, ev.wishlistUpdated, ev.postLogin].forEach(function (n) { if (n) L.addEventListener(n, function () { refresh(); }); });

    /* Save / unsave */
    document.addEventListener('click', function (e) {
      if (e.target.closest('a.swym-wishlist')) return;
      var b = e.target.closest(SEL); if (!b) return;
      if (b.dataset.busy) return; b.dataset.busy = '1'; b.classList.add('is-saving');
      var unlock = function () { delete b.dataset.busy; b.classList.remove('is-saving'); };
      var timer = setTimeout(unlock, 4000);
      var vid = b.getAttribute('data-variant-id');
      var settle = function (on, item) {
        clearTimeout(timer);
        if (on && item && !inList(list, b)) list.push(item);
        if (!on) list = list.filter(function (it) { return String(it.epi) !== String(vid); });
        setCount(list.length); render();
        document.querySelectorAll(SEL).forEach(function (x) { if (x.getAttribute('data-variant-id') === vid) { x.classList.toggle('swym-added', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); } });
        unlock();
        setTimeout(function () { refresh(); }, 6000);
      };
      e.preventDefault(); e.stopPropagation();
      var epi = parseInt(vid, 10), empi = parseInt(b.getAttribute('data-product-id'), 10);
      var du = b.getAttribute('data-product-url') || (b.closest('[data-product-handle]') ? location.origin + '/products/' + b.closest('[data-product-handle]').getAttribute('data-product-handle') : location.origin + location.pathname.replace(/\/$/, ''));
      var product = { epi: epi, empi: empi, du: du };
      var go = function () {
        var existing = inList(list, b);
        if (existing) swat.removeFromWishList(existing, function () { settle(false); }, function () { settle(true, existing); });
        else swat.addToWishList(product, function (res) { settle(true, res && res.epi ? res : product); }, function () { settle(false); });
      };
      if (ready) go(); else refresh(go);
    }, true);
    document.addEventListener('wx:variant', function () { mark(list); });

    /* Drawer */
    function open() { if (!root) return; root.hidden = false; document.body.classList.add('wxw-open'); render(); refresh(); }
    function close() { if (!root) return; root.hidden = true; document.body.classList.remove('wxw-open'); }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a.swym-wishlist'); if (a) { e.preventDefault(); e.stopPropagation(); open(); return; }
      if (e.target.closest('[data-wxw-close]')) close();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && !root.hidden) close(); });

    /* Swym items carry no stock. Pull live availability from Shopify per product, cached for the session. */
    /* Same rules as snippets/wx-gate and gate() in wx-nav.js. Returns a label when this visitor can't buy the product, '' when they can. */
    var CERT = ['nv-pro','cp-uvx','cq-professional','dquartz','cq-finest','immortal-sample','immortal','authorised applicator'];
    function gate(p) {
      var t = p.tags || [], c = (window.wx && window.wx.customer) || {}, mine = c.certs || [], hit = false, ok = false;
      CERT.forEach(function (x) { if (t.indexOf(x) > -1) { hit = true; if (mine.indexOf(x) > -1) ok = true; } });
      if (hit && !ok && t.indexOf('trade') > -1 && c.tradeTag) ok = true;
      if (hit) return ok ? '' : 'Authorised only';
      if ((t.indexOf('trade') > -1 || t.indexOf('trade-only') > -1) && !c.trade) return 'Trade only';
      return '';
    }
    var stockCache = {};
    function liveStock(it, cb) {
      var m = String(it.du || '').match(/\/products\/([^\/?#]+)/); if (!m) return cb(null);
      var h = m[1];
      if (stockCache[h]) return cb(stockCache[h]);
      fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return cb(null);
        stockCache[h] = p; cb(p);
      }).catch(function () { cb(null); });
    }
    function emailKnown() { try { return (swat.getEmail && swat.getEmail()) || (swat.user && swat.user.email) || localStorage.getItem('wx_wish_email') || ''; } catch (e) { return ''; } }

    /* Variant switch: the save (and its alerts) moves to the size they pick. Add the new variant first, then drop the old one, so a failed call never loses the save. */
    function swapVariant(it, p, v, done, fail) {
      var clash = list.find(function (x) { return x !== it && String(x.epi) === String(v.id); });
      var finish = function (item) {
        var i = list.indexOf(it);
        if (clash) { if (i > -1) list.splice(i, 1); }
        else if (i > -1) list[i] = item; else list.push(item);
        setCount(list.length); mark(list); render(); done();
        setTimeout(function () { swapping = false; }, 1500);
        setTimeout(function () { refresh(); }, 6000);
      };
      var dropOld = function (item) { swat.removeFromWishList(it, function () { finish(item); }, function () { finish(item); }); };
      swapping = true;
      if (clash) return dropOld(clash); /* that size is already saved: just merge the two rows */
      var product = { epi: v.id, empi: parseInt(it.empi, 10) || p.id, du: it.du };
      swat.addToWishList(product, function (res) {
        var item = {}, k; for (k in it) item[k] = it[k]; if (res && res.epi) for (k in res) item[k] = res[k];
        item.epi = v.id; item.pr = v.price / 100; item.op = v.compare_at_price ? v.compare_at_price / 100 : null;
        if (v.featured_image && v.featured_image.src) item.iu = v.featured_image.src;
        dropOld(item);
      }, function () { swapping = false; fail(); });
    }

    function render() {
      if (!root) return;
      var listEl = root.querySelector('[data-wxw-list]'), empty = root.querySelector('[data-wxw-empty]'), foot = root.querySelector('[data-wxw-foot]');
      if (!listEl) return;
      var pillsMax = parseInt(root.getAttribute('data-wxw-pills-max'), 10) || 3;
      var ROW = '<a class="wxw__img" data-wxw-link href="#"><img data-wxw-img alt="" loading="lazy"></a><div class="wxw__info"><div class="wxw__brand" data-wxw-brand></div><a class="wxw__name" data-wxw-link data-wxw-title href="#"></a><div class="wxw__variant" data-wxw-variant hidden></div><div class="wxw__price"><strong data-wxw-price></strong><s data-wxw-was hidden></s><span class="wxw__tag" data-wxw-tag hidden></span></div><div class="wxw__note" data-wxw-note hidden></div><button type="button" class="wxw__add" data-wxw-add hidden>Add to cart</button></div><button type="button" class="wxw__remove" data-wxw-remove aria-label="Remove">&#215;</button>';
      listEl.innerHTML = '';
      empty.hidden = list.length > 0; foot.hidden = list.length === 0;
      list.forEach(function (it) {
        var n = document.createElement('div'); n.className = 'wxw__row'; n.innerHTML = ROW;
        var cur = it.epi;
        var img = n.querySelector('[data-wxw-img]'); img.src = it.iu || ''; img.alt = it.dt || '';
        n.querySelectorAll('[data-wxw-link]').forEach(function (a) { a.href = it.du || '#'; });
        n.querySelector('[data-wxw-brand]').textContent = it.bt || '';
        n.querySelector('[data-wxw-title]').textContent = (it.dt || '').replace(/^(.*?)\s*\|\s*Waxit.*$/, '$1').replace(/^Get\s+/, '').replace(/\s+Online.*$/, '');
        n.querySelector('[data-wxw-price]').textContent = it.pr != null ? money(it.pr) : '';
        var was = n.querySelector('[data-wxw-was]'); if (it.op && Number(it.op) > Number(it.pr)) { was.hidden = false; was.textContent = money(it.op); }
        var tag = n.querySelector('[data-wxw-tag]'), note = n.querySelector('[data-wxw-note]'), add = n.querySelector('[data-wxw-add]'), vbox = n.querySelector('[data-wxw-variant]');
        var applyStock = function (avail, qty) {
          tag.hidden = true; note.hidden = true; add.hidden = true; tag.className = 'wxw__tag';
          if (avail === false) { tag.hidden = false; tag.textContent = 'Sold out'; note.hidden = false; note.textContent = "Alert set. We'll email you the moment it's back."; }
          else { add.hidden = false; if (qty != null && qty > 0 && qty <= 3) { tag.hidden = false; tag.textContent = 'Only ' + qty + ' left'; tag.classList.add('wxw__tag--low'); } }
        };
        var applyVariant = function (p, v) {
          if (v.price != null) n.querySelector('[data-wxw-price]').textContent = moneyCents(v.price);
          var was = n.querySelector('[data-wxw-was]'); if (v.compare_at_price && v.compare_at_price > v.price) { was.hidden = false; was.textContent = moneyCents(v.compare_at_price); } else { was.hidden = true; }
          applyStock(!!v.available, v.inventory_quantity != null ? v.inventory_quantity : null);
          if (v.featured_image && v.featured_image.src) img.src = v.featured_image.src;
          if (p.variants.length > 1 && it.du) n.querySelectorAll('[data-wxw-link]').forEach(function (a) { a.href = it.du.split('?')[0] + '?variant=' + v.id; });
          vbox.querySelectorAll('[data-wxw-pill]').forEach(function (b) { var on = b.getAttribute('data-wxw-pill') === String(v.id); b.classList.toggle('is-selected', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
          var sel = vbox.querySelector('select'); if (sel) sel.value = String(v.id);
        };
        /* Same rule as the product page: pills up to pillsMax variants, dropdown above that or when there is more than one option. */
        var buildSwitcher = function (p, v) {
          if (!p.variants || p.variants.length < 2) return;
          var pick = function (id) {
            var nv = p.variants.find(function (x) { return String(x.id) === String(id); });
            if (!nv || String(nv.id) === String(cur)) return;
            var prev = p.variants.find(function (x) { return String(x.id) === String(cur); }) || v;
            cur = nv.id; applyVariant(p, nv);
            vbox.classList.add('is-busy'); add.disabled = true;
            swapVariant(it, p, nv, function () {}, function () { cur = prev.id; applyVariant(p, prev); vbox.classList.remove('is-busy'); add.disabled = false; });
          };
          var label = (p.options || []).map(function (o) { return o.name || o; }).join(' / ') || 'Option';
          vbox.innerHTML = '';
          if (p.variants.length > pillsMax || (p.options || []).length > 1) {
            var sel = document.createElement('select'); sel.className = 'wxw__select'; sel.setAttribute('aria-label', label);
            p.variants.forEach(function (x) { var o = document.createElement('option'); o.value = String(x.id); o.textContent = x.title + (x.available ? '' : ' · Sold out'); sel.appendChild(o); });
            sel.addEventListener('change', function () { pick(sel.value); });
            vbox.appendChild(sel);
          } else {
            vbox.setAttribute('role', 'radiogroup'); vbox.setAttribute('aria-label', label);
            p.variants.forEach(function (x) {
              var b = document.createElement('button'); b.type = 'button'; b.className = 'wxw__pill' + (x.available ? '' : ' is-soldout');
              b.setAttribute('role', 'radio'); b.setAttribute('data-wxw-pill', String(x.id)); b.textContent = x.title;
              if (!x.available) b.title = 'Sold out';
              b.addEventListener('click', function () { pick(x.id); });
              vbox.appendChild(b);
            });
          }
          vbox.hidden = false;
        };
        applyStock(true, null);
        /* 5 Oct 2026: trade-only and authorised-installer products show a label instead of price and Add (gate() above, same rules as snippets/wx-gate). */
        var locked = false;
        liveStock(it, function (p) {
          if (!p) return;
          var g = gate(p);
          if (g) {
            locked = true;
            n.querySelector('[data-wxw-price]').textContent = g;
            n.querySelector('[data-wxw-was]').hidden = true;
            tag.hidden = true; note.hidden = true; add.hidden = true; vbox.hidden = true;
            return;
          }
          var v = (p.variants || []).find(function (x) { return String(x.id) === String(it.epi); }) || p.variants[0];
          if (!v) return;
          buildSwitcher(p, v);
          applyVariant(p, v);
        });
        add.addEventListener('click', function () {
          if (locked) return;
          add.disabled = true; add.textContent = 'Adding…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: cur, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) })
            .then(function (r) { return r.json(); })
            .then(function (state) { close(); var cd = document.querySelector('cart-drawer'); if (cd && cd.renderContents && state.sections) cd.renderContents(state); else location.href = '/cart'; })
            .catch(function () { add.disabled = false; add.textContent = 'Add to cart'; });
        });
        n.querySelector('[data-wxw-remove]').addEventListener('click', function () {
          n.style.opacity = '.4';
          swat.removeFromWishList(it, function () { list = list.filter(function (x) { return x !== it; }); setCount(list.length); mark(list); render(); }, function () { n.style.opacity = ''; });
        });
        listEl.appendChild(n);
      });
      var em = emailKnown(), form = root.querySelector('[data-wxw-email-form]'), set = root.querySelector('[data-wxw-email-set]');
      form.hidden = !!em; set.hidden = !em; if (em) root.querySelector('[data-wxw-email]').textContent = em;
    }
    var form = root && root.querySelector('[data-wxw-email-form]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = form.querySelector('input').value.trim(); if (!v) return;
      var done = function () { try { localStorage.setItem('wx_wish_email', v); } catch (x) {} render(); };
      try { if (typeof swat.setEmail === 'function') swat.setEmail(v, done, done); else if (swat.validateSync) swat.validateSync({ email: v }, done, done); else if (swat.User && swat.User.setEmail) swat.User.setEmail(v, done, done); else done(); } catch (x) { done(); }
    });
    var change = root && root.querySelector('[data-wxw-email-change]');
    if (change) change.addEventListener('click', function () { try { localStorage.removeItem('wx_wish_email'); } catch (x) {} root.querySelector('[data-wxw-email-form]').hidden = false; root.querySelector('[data-wxw-email-set]').hidden = true; });
  });
})();
